<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/speaker/ysq.jpg" alt="功放系列">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">Speaker Series</div>
                <div class="detail-banner-desc">
                    Independent planning and design;<br />
                    Advanced acoustic technology delivers excellent sound quality;<br />
                    Spanning from entry-level to top-tier, covering multiple performance levels to meet various acoustic
                    requirements;<br />
                    It features high performance, customized layout, waterproof speakers, complete range and
                    environmental friendliness.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AG1 High-Fidelity Series</div>
                    <div class="detail-desc">
                        <div>
                            High power, high reliability and excellent weather resistance
                        </div>
                        <div>
                            Outstanding mid & high frequency extension and low-frequency output performance
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/speaker/AG1.jpg" alt="AG1 High-Fidelity Series">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Product Advantages
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Enlarged magnetic circuit design — High output capacity<br />Low
                                        frequency response down to 40Hz — Deep low-frequency extension<br />Compact
                                        subwoofer options available — Flexible installation layout</div>
                                    <div class="k">Woofer & Subwoofer Units</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Midrange driver with enlarged magnetic circuit — High working
                                        efficiency</div>
                                    <div class="k">Midrange Units</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Silk dome tweeter — Delicate and smooth sound</div>
                                    <div class="k">Tweeter Units</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">High-power voice coil — Superior power handling<br />Aluminum cone /
                                        Composite paper cone — Sharp transient response and crisp sound texture</div>
                                    <div class="k">Other Features</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AG2 Premium Series</div>
                    <div class="detail-desc">
                        <div>
                            Higher power output, superior reliability and enhanced weather resistance
                        </div>
                        <div>
                            Excellent high-frequency extension, dynamic midrange performance and powerful low-frequency
                            output
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Product Advantages
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">More robust voice coil design — Improved reliability<br />Low
                                        frequency response down to 30Hz — Deeper low-frequency extension</div>
                                    <div class="k">Woofer & Subwoofer Units</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Dual magnet structure — Higher working efficiency</div>
                                    <div class="k">Midrange Units</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Silk dome tweeter — Delicate and smooth sound<br />Metal dome tweeter
                                        — Bright tone with distinct metallic timbre</div>
                                    <div class="k">Tweeter Units</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Rare-earth magnet as standard — Stronger driving force and lighter
                                        weight<br />Fiberglass / Kevlar composite cone — Premium sound reproduction
                                    </div>
                                    <div class="k">Other Features</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/speaker/AG2.jpg" alt="AG2 Premium Series">
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">AG3 Luxury Series</div>
                    <div class="detail-desc">
                        <div>
                            Ultra-high power, ultimate reliability and maximum weather resistance
                        </div>
                        <div>
                            Exceptional high-frequency dynamics, rich midrange timbre and formidable low-frequency
                            output
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/speaker/AG3.jpg" alt="AG3 Luxury Series">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Product Advantages
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Low frequency response down to 20Hz — Stunning ultra-deep bass
                                        performance<br />Oval-shaped drivers optional — Ideal for special space
                                        installation</div>
                                    <div class="k">Woofer & Subwoofer Units</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Full-range Kevlar woven midrange cones — Outstanding tonal quality
                                    </div>
                                    <div class="k">Midrange Units</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Aerospace-grade titanium dome tweeter — Superior resolution &
                                        frequency extension</div>
                                    <div class="k">Tweeter Units</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Full-series rare-earth magnets — Optimized acoustic
                                        performance<br />Cast aluminum frame — Enhanced structural support & stability
                                    </div>
                                    <div class="k">Other Features</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: 'Speaker Series - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/electronics/speaker.html'
};

import { createApp } from 'vue';
import App from './speaker.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./speaker.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
